import { useRef } from "react";
import { X, Download } from "lucide-react";
import UserProfilePanel from "./UserProfilePanel";
import WhatsTaskDetail from "./WhatsTaskDetail";
import CustomAudioPlayer from "../../../../../shared/ui/CustomAudioPlayer";

// 02.7-settings.md paso c -- panel lateral derecho de WhatsPanel.jsx. Perfil de usuario, un
// placeholder genérico, o (epic B2 de la integración main→dev) un visor de media a pantalla
// completa. Ancho redimensionable arrastrando el borde izquierdo (persistido por el container).
export default function WhatsRightPanel({ activeRightPanel, chat, presences, messages, allChats = [], width = 700, onResize, onClose, onPriorityChange, onSelectChat, onOpenTask }) {
  const isUserPanel = activeRightPanel.id === "user" || activeRightPanel.type === "user";
  const isMediaPanel = activeRightPanel.type === "media";
  const isTaskPanel = activeRightPanel.type === "task";
  const dragRef = useRef(null);

  const handleResizeStart = (e) => {
    if (!onResize) return;
    e.preventDefault();
    const startX = e.clientX;
    let last = startX;
    const onMove = (ev) => {
      // arrastrar hacia la izquierda ensancha el panel
      onResize(last - ev.clientX);
      last = ev.clientX;
    };
    const onUp = () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    };
    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  };

  return (
    <div
      className="whats-panel-info"
      style={{
        position: "absolute",
        left: "100%",
        top: 0,
        width: `${width}px`,
        height: "100%",
        backgroundColor: "#fff",
        borderLeft: "1px solid #e0e0e0",
        boxShadow: "4px 0 15px rgba(0,0,0,0.1)",
        zIndex: 9,
        display: "flex",
        flexDirection: "column",
        borderRadius: "0 var(--radius-xl) var(--radius-xl) 0",
        overflow: "hidden",
      }}
    >
      <div
        ref={dragRef}
        onMouseDown={handleResizeStart}
        title="Ajustar ancho"
        style={{ position: "absolute", left: 0, top: 0, width: "6px", height: "100%", cursor: "ew-resize", zIndex: 1 }}
      />

      {!isUserPanel && (
        <div style={{ height: "60px", display: "flex", alignItems: "center", padding: "0 var(--space-5)", borderBottom: "1px solid #eee", backgroundColor: "#fafafa", boxSizing: "border-box" }}>
          <h2 style={{ margin: 0, fontSize: "16px", color: "#111", flex: 1, fontWeight: "500", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {activeRightPanel.label}
          </h2>
          {isMediaPanel && (
            <a href={activeRightPanel.url} download target="_blank" rel="noopener noreferrer" style={{ color: "#666", padding: "6px", display: "flex" }}>
              <Download size={20} />
            </a>
          )}
          <button onClick={onClose} style={{ background: "transparent", border: "none", cursor: "pointer", padding: "6px", display: "flex", alignItems: "center", justifyContent: "center", color: "#666" }}>
            <X size={20} />
          </button>
        </div>
      )}

      <div style={{ padding: 0, flex: 1, overflowY: "auto", color: "#555", backgroundColor: isMediaPanel ? "#0b141a" : "#fff" }}>
        {isUserPanel ? (
          <UserProfilePanel chat={chat} presences={presences} messages={messages} allChats={allChats} onClose={onClose} onPriorityChange={onPriorityChange} onSelectChat={onSelectChat} onOpenTask={onOpenTask} />
        ) : isMediaPanel ? (
          <MediaViewer url={activeRightPanel.url} mime={activeRightPanel.mime} filename={activeRightPanel.filename} />
        ) : isTaskPanel ? (
          <WhatsTaskDetail taskId={activeRightPanel.taskId} />
        ) : (
          <div style={{ padding: "var(--space-5)" }}>
            <p>Contenido para <strong>{activeRightPanel.label}</strong> estará disponible aquí.</p>
          </div>
        )}
      </div>
    </div>
  );
}

function MediaViewer({ url, mime, filename }) {
  const t = String(mime || "");
  const isVideo = t.includes("video") || /\.(mp4|webm|mov)(\?.*)?$/i.test(url);
  const isImage = t.includes("image") || /\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i.test(url);
  const isAudio = t.includes("audio") || /\.(mp3|wav|ogg|m4a)(\?.*)?$/i.test(url);

  return (
    <div style={{ minHeight: "100%", display: "flex", alignItems: "center", justifyContent: "center", padding: "var(--space-5)" }}>
      {isImage ? (
        <img src={url} alt={filename} style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }} />
      ) : isVideo ? (
        <video src={url} controls style={{ maxWidth: "100%", maxHeight: "80vh" }} />
      ) : isAudio ? (
        <div style={{ width: "100%", maxWidth: "480px" }}><CustomAudioPlayer src={url} filename={filename} /></div>
      ) : (
        <a href={url} download target="_blank" rel="noopener noreferrer" style={{ color: "#fff", background: "#00a884", padding: "12px 20px", borderRadius: "var(--radius-md)", textDecoration: "none", fontWeight: 600 }}>
          Descargar {filename}
        </a>
      )}
    </div>
  );
}
